// @ts-nocheck

export const USER_INFO_DEPOSIT_BTN_WIDTH = 1.5;
export const USER_INFO_AVATAR_BTN_WIDTH = 1.75;
export const USER_INFO_SIDE_MARGIN = 0.8;
export const USER_INFO_AMOUNT_LEFT_MARGIN = 0.3;
export const USER_INFO_USER_BUTTON_MARGIN_RIGHT = 0.4;
export const USER_INFO_AMOUNT_ICON_WIDTH = 1.2;
